import initAxios from "./axios-service";

export default initAxios;